const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const AIProcessLogQueryURL: any = {
    GetUserHistory: Backofficebff + `/v1/aistudioanalytics/my-transactions`,
    GetHistoryDetail: (id: number) => Backofficebff + `/v1/aistudioanalytics/transaction-detail/${id}`,
};

